<div class="modal-header">
    <h4 class="modal-title">{{ isNew ? 'Add Language Code' : 'Edit Language Code' }}</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
</div>
<div class="modal-body">
    @if (errorMessage) {
        <div class="alert alert-danger py-1 px-2 mb-2">{{ errorMessage }}</div>
    }
    <form #languageCodeForm="ngForm">
        <!-- ISO 639-1 -->
        <div class="form-group row mb5">
            <label for="languageCode_ISO639_1" class="col-sm-3 col-form-label">ISO 639-1 <span class="req-color">*</span></label>
            <div class="col-sm-9">
                <input type="text" class="form-control" id="languageCode_ISO639_1" name="languageCode_ISO639_1"
                    [(ngModel)]="model.languageCode_ISO639_1" maxlength="2" required>
            </div>
        </div>

        <!-- ISO 639-3 -->
        <div class="form-group row mb5">
            <label for="languageCode_ISO639_3" class="col-sm-3 col-form-label">ISO 639-3 <span class="req-color">*</span></label>
            <div class="col-sm-9">
                <input type="text" class="form-control" id="languageCode_ISO639_3" name="languageCode_ISO639_3"
                    [(ngModel)]="model.languageCode_ISO639_3" maxlength="3" required>
            </div>
        </div>

        <!-- Language Name -->
        <div class="form-group row mb5">
            <label for="languageName" class="col-sm-3 col-form-label">Language Name <span class="req-color">*</span></label>
            <div class="col-sm-9">
                <input type="text" class="form-control" id="languageName" name="languageName"
                    [(ngModel)]="model.languageName" required>
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="cancel()">Cancel</button>
    <button type="button" class="btn btn-outline-dark" (click)="save()"
        [disabled]="isSaving || !languageCodeForm.valid">
        @if (isSaving) {
            <span class="spinner-border spinner-border-sm me-1" role="status"></span>
        }
        Save
    </button>
</div>
